import { Fragment, ReactNode } from 'react';
import { Carousel as CarouselZDS } from '@zapier/design-system';
import styled from '@emotion/styled';
import { mediaQueries } from '../../constants';
import { useScreenSize } from '../../hooks/useScreenSize';

type Props = {
  children: ReactNode;
  onActiveSlideChange: (currentSlide: number, previousSlide: number) => void;
};
export const Carousel = ({ children, onActiveSlideChange }: Props) => {
  const { isDesktop, isMobile, isKnown } = useScreenSize();

  const slideWidth = isMobile ? 300 : 650;

  if (!isKnown) return <Fragment />;

  return (
    <CarouselContainer data-testid="carousel">
      <CarouselZDS
        onActiveSlideChange={onActiveSlideChange}
        paginatorStyle="indicator"
        showArrows={isDesktop}
        slideWidth={slideWidth}
      >
        {children}
      </CarouselZDS>
      <CarouselOverlay />
    </CarouselContainer>
  );
};

const CarouselContainer = styled.div`
  position: relative;
`;

const CarouselOverlay = styled.div`
  ${mediaQueries.desktop} {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 423px;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  }
`;
